import React from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import {ImageUploader} from '../uploaders';
import Spinner from '../spinner/spinner';

/** @class GiftCardBackground
 * A component for editing the gift card display's background
 */
export default class GiftCardBackground extends ReactFireComponent {
  /** @constructor
    * Constructs a new instance of GiftCardBackground
    */
  constructor(props) {
    super(props);
    this.state = {}
    this.dataURL = this.props.dataURL + '/giftCardsBackground';
    this.handleImageUpload = this.handleImageUpload.bind(this);
  }
  /** @function componentWillMount
    * Connects the component to its corresponding
    * data in the Firebase realtime database
    */
  componentWillMount() {
    this.bindAsObject(this.dataURL, 'background');
  }
  /** @function componentWillUnmount
    * Disconnects the component from the
    * Firebase realtime database
    */
  componentWillUnmount() {
    this.unbind('background');
  }
  /** @function handleImageUpload
    * Handles updates to images by updating the
    * firebase reference
    * @param {String} name - the name of the image property
    * @param {Url} url - the url for the new image
    */
  handleImageUpload(name, url) {
    firebase.database().ref(this.dataURL).set(url);
  }
  /** @function render
    * Renders the component
    */
  render() {
    if(!this.state.background) return <Spinner/>
    return (
      <ImageUploader
          name="background"
          value={this.state.background}
          dataURL={this.props.dataURL}
          onUpload={(url)=>this.handleImageUpload('background', url)}
          />
    );
  }
}



// WEBPACK FOOTER //
// ./src/gift-card-editor/gift-card-background.js